import { QuestSeries } from "@joonapp/web-shared"
import { create } from "zustand"

interface QuestDndSectionsStore {
  sections: [string, QuestSeries[]][]
  setSections: (sections: [string, QuestSeries[]][]) => void
  userHasMadeChanges: boolean
  setUserHasMadeChanges: (userHasMadeChanges: boolean) => void
}

export const useQuestDndSectionsStore = create<QuestDndSectionsStore>(
  (set) => ({
    sections: [],
    setSections: (sections) => set({ sections }),
    userHasMadeChanges: false,
    setUserHasMadeChanges: (userHasMadeChanges) => set({ userHasMadeChanges }),
  })
)
